import React from "react";
import PropTypes from "prop-types";
import { ImageUrl } from "../../utils/constants";
import {LaunchIcon} from '../../utils/icons'
import {
  ChallengeCard,
  ImageCard,
  BottomCard
} from "../ChallengeDashboardV2/FeatureChallengeStyle";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import LazyImage from "../common/LazyImage/LazyImage";

class FeatureCompanyChallenge extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const { challenge } = this.props;
    return (
      <ChallengeCard width="100%">
        <ImageCard
        >
          <LazyImage src={`${ImageUrl}/${challenge?.image}`} alt="challenge" />
        </ImageCard>
        <BottomCard>
          <div
            className="challenge-name"
          >
            <div className="name">{(challenge?.title)}</div>
          </div>
          <div style={{
            width: '642px',
            color: '#669db7',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: "justify",
            fontSize:'16px',
            fontWeight:400,
            lineHeight:'20px',
            display: '-webkit-box',
            '-webkit-line-clamp': 4,
            '-webkit-box-orient': 'vertical',
            height: '80px',  
            marginBottom:'15px',
            fontFamily:'rubik-regular'
          }}>
            {(challenge.description)}
          </div>
          <div
            className="button"
          >
            {("Launch a Challenge")}<div className="icon"><LaunchIcon/></div>
          </div>
        </BottomCard>
      </ChallengeCard>
    );
  }
}

FeatureCompanyChallenge.propTypes = {
  challenge: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  featuredWith: PropTypes.number,
  toggleDummyChallenges: PropTypes.func,
  isDummyChallenge: PropTypes.bool,
  padding: PropTypes.string,
  joinOrLeaveChallenge: PropTypes.func.isRequired,
  t: PropTypes.func,
  challengeAttendees: PropTypes.array
};

export default connect(null, null)(withTranslation()(FeatureCompanyChallenge));
